export { PersonalDataDetailsScreen } from './PersonalDataDetailsScreen';
